import i18n  from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./translations/en.json";
import translationDE from "./translations/de.json";

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: translationEN
            },
            de: {
                translation: translationDE
            }
        },
        lng: "de",
        fallbackLng: "de",
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;
    
